import { useState } from "react";
import copy from "fast-copy";

const usePureState = <T extends any>(initialState: T) => {
    return useState<T>(copy(initialState));
};

export default usePureState;
